module.exports = __webpack_public_path__ + "img/09.0e217083.png";